export const CATEGORY_FIELDS = `
    id
    label
    parentId
    type
    image
    createdAt
`;
